import { AppState } from '../../types';
import { RouterState, Invitation } from './types';

export const selectRouter = (state: AppState): RouterState => state.app.router;

export const selectInvitation = (state: AppState): Invitation => state.app.invitation;
